// extracted by mini-css-extract-plugin
export default {"tabContainer":"Billing_tabContainer__Qfl+B","tabLabel":"Billing_tabLabel__Xkei0","selectedTabLabel":"Billing_selectedTabLabel__hm1k8"};